import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers';
import store from '@/store';
import iView from 'iview';

Vue.use(Router);
const router = new Router({
    routes,
});
const LOCK_PAGE_NAME = 'locking';
const LOGIN_PAGE_NAME = 'login';
const REGISTER_PAGE_NAME = 'register';
const default_permit = ['login', 'register', 'index', 'home', 'my_info', 'error_401', 'error_404', 'locking'];

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    // 从vuex取锁定状态
    const IS_LOCKED = store.state.app.lockInfo.isLock;
    // // 当前是锁定状态并且用户要跳转到的页面不是解锁页面
    if (IS_LOCKED && to.name !== LOCK_PAGE_NAME) {
        next({
            replace: true, // 重定向到解锁页面
            name: LOCK_PAGE_NAME,
        });
        return;
    }
    // 当前未锁定且用户要跳转到的页面是解锁页面
    if (!IS_LOCKED && to.name === LOCK_PAGE_NAME) {
        next(false); // 不做跳转
        iView.LoadingBar.finish();
        return;
    }
    // 未登录
    if (!store.state.user.token) {
        if (to.name !== LOGIN_PAGE_NAME && to.name !== REGISTER_PAGE_NAME) {
            //跳转的页面不是登录页或注册页、跳转到登录页
            next({name: LOGIN_PAGE_NAME});
        } else {
            // 否则正常跳转
            next();
        }
        return;
    }
    // 已登录且要跳转的页面是登录页或注册页、跳转到home页
    if (to.name === LOGIN_PAGE_NAME || to.name == REGISTER_PAGE_NAME) {
        next({name: 'home'});
        return;
    }
    // 已登录且要跳转的页面是普通页面

    // 通过用户权限和跳转的页面的name来判断是否有权限访问
    /*if (default_permit.includes(to.name)
        || store.state.user.access.some(p => p.routerName == to.name)) {*/
        // 有权限，可访问
        next();
    //}
    //else {
        // 无权限，重定向到401页面
    //    next({replace: true, name: 'error_401'});
    //}
});

router.afterEach(to => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router;
